import ImagesMainBannerApril2025BottlesOfTheMonthWebp from '@/public/images/main-banner/april-2025/bottles-of-the-month.webp';
import ImagesMainBannerApril2025BowmoreSelectionWebp from '@/public/images/main-banner/april-2025/bowmore-selection.webp';

export {
  ImagesMainBannerApril2025BottlesOfTheMonthWebp,
  ImagesMainBannerApril2025BowmoreSelectionWebp,
};
